<template>
    <div class="content-wrapper">
        <div class="container">
            <div class="text-center" v-if="!compositionLoaded">
                <div class="loading-animation"><div></div><div></div><div></div></div>
            </div>
            <div class="row" v-if="compositionLoaded">
                <div class="col">
                    <div class="sinlge-product-wrap box-module">
                        <div class="row">
                            <div class="col-lg-6">
                                <h5>
                                    <!-- Dit is een samenstelling, welke bestaat uit een aantal artikelen. Hieronder staan alle artikelen die hierin zitten.
                                    Bij aantal staat er hoeveel er in de winkelwagen komen. -->
                                </h5>
                            </div>
                            <div class="col-lg-6">
                                <div class="quick-view-content">
                                    <div class="product-info">
                                        <h2>{{composition.Description}}</h2>
                                    </div>
                                    <div v-if="isUserLoggedIn" class="quick-add-to-cart">
                                        <div class="modal-cart">
                                            <div>
                                                <label class="control-label">
                                                    Startdatum
                                                    <date-picker v-model="start" :config="datePickerStartOptions"></date-picker>
                                                </label>
                                            </div>
                                            <div v-if="item.ItemType != 'Sales'">
                                                <label class="control-label">
                                                    Einddatum
                                                    <date-picker v-model="end" :config="datePickerEndOptions"></date-picker>
                                                </label>
                                            </div>
                                            <div class="quantity">
                                                <label>Hoeveelheid</label>
                                                <div class="cart-plus-minus">
                                                    <input type="number" name="amount" v-model="amount" min="0" step="1" class="input-box">
                                                </div>
                                            </div>
                                            <div v-if="availabilityMessage" class="alert" :class="availabilityClass" role="alert" >{{ availabilityMessage }}</div>
                                            <button class="btn" :class="shoppingButtonClass" :disabled="!isAvailable" @click="addCartItem()">In winkelwagen</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="product-info-detailed">
                                    <div class="discription-tab-menu">
                                        <ul role="tablist" class="nav">
                                            <li class="active"><a href="#description" data-toggle="tab" class="active show">Artikelen:</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row composition-item" v-for="item in composition.Items" :key="item.ItemID">
                            <div class="col-lg-3">
                                <div class="single-product-tab">
                                    <div class="zoomWrapper">
                                        <div :if="item.ImageUrl" :id="item.Description" class="zoomWrapper single-zoom">
                                            <img id="zoom1" :src="item.ImageUrl + '&v=3'" data-zoom-image="item.ImageUrl" :alt="item.Description">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-7">
                                <h3 style="padding: 10px;">{{ item.Description }}</h3>
                                <p v-html="item.Notes" style="padding: 10px;"></p>
                            </div>
                            <div class="col-lg-2">
                                <!-- <p><strong>Artikel:</strong><br>
                                    {{ item.Description }}</p> -->
                                <p v-if="item.Brand"><strong>Merk:</strong> {{ item.Brand }}</p>
                                <p><strong>Aantal:</strong> {{ item.Amount }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ItemService from '@/services/ItemService.js'
import CartService from '@/services/CartService.js'
import AuthorizationService from '@/services/AuthorizationService'
import TranslationService from '@/services/TranslationService'
import datePicker from 'vue-bootstrap-datetimepicker'
import swal from 'sweetalert'
import moment from 'moment'

require('moment/locale/nl')
require('vue-moment')

export default {
    data () {
        return {
            composition: null,

            amount: 1,
            start: moment().format('DD-MM-YYYY'),
            end: moment().add(1, 'days').format('DD-MM-YYYY'),
            datePickerStartOptions: {
                format: 'DD-MM-YYYY',
                useCurrent: false,
                minDate: moment(),
                defaultDate: moment()
            },
            datePickerEndOptions: {
                format: 'DD-MM-YYYY',
                useCurrent: false,
                minDate: moment().add(1, 'days'),
                defaultDate: moment().add(1, 'days')
            },
            compositionLoaded: false,
            isAvailable: false,
            availabilityMessage: 'Niet voldoende voorraad als set.',
            availabilityClass: 'alert-danger',
            shoppingButtonClass: '',
            item: [],
            isUserLoggedIn: false
        }
    },
    components: {
        datePicker
    },
    methods: {
        async getComposition () {
            this.composition = await ItemService.getComposition(this.$route.params.compositionID)
        },

        async getAvailabilityForPeriod () {
            let sufficientStock
            for (let item of this.composition.Items) {
                let compositionItem = {
                    itemID: item.ItemID,
                    start: moment(this.start, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                    end: moment(this.end, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                    amount: item.Amount * this.amount
                }

                sufficientStock = await CartService.checkSufficientStock(compositionItem)
                if (!sufficientStock.HasStock) {
                    break
                }
            }
            this.setAvailable(sufficientStock)
            // debugger
            // if (!sufficientStock).HasStock {
            //     this.setAvailable(sufficientStock)
            //     break
            // } else {
            //     this.setAvailable(sufficientStock)
            // }
        },

        async addCartItem () {
            for (let item of this.composition.Items) {
                let cartItem = {
                    compositionID: this.composition.CompositionID,
                    itemID: item.ItemID,
                    itemDescription: item.Description,
                    item: item,
                    amount: parseInt(item.Amount),
                    start: moment(this.start, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                    end: moment(this.end, 'DD-MM-YYYY').format('YYYY-MM-DD')
                    // start: this.start,
                    // end: item.ItemType === 'Sales' ? '' : moment(this.end, 'DD-MM-YYYY').format('YYYY-MM-DD')
                }
                if (item.ItemType === 'Sales') {
                    cartItem.end = ''
                }
                if (this.checkDateSelectionProblems() !== false) {
                    await CartService.addCartItem(cartItem)
                    this.showContinueShoppingPopup()
                }
            }
        },

        async setup () {
            await this.getComposition()

            let isUserLoggedIn = await AuthorizationService.isUserLoggedIn()
            if (isUserLoggedIn) {
                this.isUserLoggedIn = true
                this.getAvailabilityForPeriod()
            }
            this.compositionLoaded = true
        },

        setAvailable (sufficientStock) {
            this.isAvailable = sufficientStock.HasStock
            this.isItemAvailableForPeriod = this.isAvailable
            this.availabilityMessage = this.isAvailable ? 'Artikel is op voorraad' : 'Niet voldoende voorraad als set.'
            this.availabilityClass = this.isAvailable ? 'alert-success' : 'alert-danger'
            this.shoppingButtonClass = this.isAvailable ? 'btn-primary' : ''
        },

        showContinueShoppingPopup () {
            let _this_ = this
            let popup = {
                text: TranslationService.get('ITEM_PUT_IN_CART'),
                icon: 'success',
                buttons: {
                    continue_shopping: {
                        text: TranslationService.get('CONTINUE_SHOPPING'),
                        value: 'continue_shopping'
                    },
                    to_cart: {
                        text: TranslationService.get('TO_CART'),
                        value: 'to_cart'
                    }
                }
            }

            swal(popup).then(value => {
                if (value === 'continue_shopping') {
                    _this_.$router.push({ name: 'products' })
                } else if (value === 'to_cart') {
                    _this_.$router.push({
                        name: 'cart'
                    })
                } else {
                    this.getAvailabilityForPeriod()
                }
            })
        },

        checkDateSelectionProblems () {
            setTimeout(
                function () {
                    // Check if end is smaller then start date, and change it to start date + 1 day if it is the case
                    if (moment(this.start, 'DD-MM-YYYY') >=
                        moment(this.end, 'DD-MM-YYYY')
                    ) {
                        this.end = moment(this.start, 'DD-MM-YYYY')
                            .add('days', 1)
                            .format('DD-MM-YYYY')
                    }

                    // Set min End date to Start date + 1 day
                    this.datePickerEndOptions.minDate = moment(
                        this.start,
                        'DD-MM-YYYY'
                    ).add('days', 1)
                }.bind(this),
                300
            )
        }
    },
    watch: {
        amount: function (value) {
            value === '' ? this.setAvailable(false) : this.getAvailabilityForPeriod()
        },
        start: function (value) {
            value === '' ? this.setAvailable(false) : this.getAvailabilityForPeriod()
            this.checkDateSelectionProblems()
        },
        end: function (value) {
            value === '' ? this.setAvailable(false) : this.getAvailabilityForPeriod()
            this.checkDateSelectionProblems()
        }
    },
    mounted () {
        this.setup()
    }
}
</script>

<style scoped>
.composition-item {
    padding: 10px;
    margin: 10px;
    border: 1px solid;
    border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Products/SingleComposition.vue